'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _logoLocal = require('./logo.local.css');

var _logoLocal2 = _interopRequireDefault(_logoLocal);

var _apps = require('./marks/apps.svg');

var _apps2 = _interopRequireDefault(_apps);

var _custom = require('./marks/custom.svg');

var _custom2 = _interopRequireDefault(_custom);

var _intelligence = require('./marks/intelligence.svg');

var _intelligence2 = _interopRequireDefault(_intelligence);

var _servers = require('./marks/servers.svg');

var _servers2 = _interopRequireDefault(_servers);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function renderEntity(entity) {
  switch (entity) {
    case 'intelligence':
      return _intelligence2.default;

    case 'custom':
      return _custom2.default;

    case 'apps':
      return _apps2.default;

    case 'servers':
      return _servers2.default;

    default:
      return null;
  }
}

var EntityLogo = function EntityLogo(_ref) {
  var entity = _ref.entity,
      color = _ref.color;
  return _react2.default.createElement('span', {
    className: (0, _classnames2.default)(_logoLocal2.default.base, _logoLocal2.default[color]),
    dangerouslySetInnerHTML: {
      __html: renderEntity(entity)
    }
  });
};

EntityLogo.defaultProps = {
  color: 'light'
};
EntityLogo.propTypes = {
  entity: _propTypes2.default.oneOf(['intelligence', 'custom', 'apps', 'servers']).isRequired,
  color: _propTypes2.default.oneOf(['dark', 'light', 'currentColor'])
};
exports.default = EntityLogo;